import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { SpecialityFeeResponse, StudentSpecialityFeeRequest } from "../../models/dtos";

export const specialityFeesApi = createApi({
  reducerPath: "specialityFeesApi",
  baseQuery: baseAuthQuery("SpecialityFees"),
  tagTypes: ["SpecialityFee"],
  endpoints: (builder) => ({
    getSpecialityFees: builder.query<ApiResponse<SpecialityFeeResponse[]>, void>({
      query: () => "",
      providesTags: ["SpecialityFee"],
    }),
    getSpecialityFeeById: builder.query<ApiResponse<SpecialityFeeResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ["SpecialityFee"],
    }),
    updateSpecialityFee: builder.mutation<ApiResponse<SpecialityFeeResponse>, Partial<SpecialityFeeResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ["SpecialityFee"],
    }),
    deleteSpecialityFee: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ["SpecialityFee"],
    }),
    getStudentSpecialityFee: builder.query<ApiResponse<SpecialityFeeResponse>, Partial<StudentSpecialityFeeRequest>>({
      query: (query) => {
        return {
          url: "adminapp/GetStudentSpecialityFee",
          method: "POST",
          body: query,
        };
      },
    }),
  }),
});
